import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/anime';
import NewsletterForm from './NewsletterForm';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100">
      <div className="mx-auto grid grid-cols-1 gap-10 px-4 md:px-6 py-12 md:py-16 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="动漫网首页">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 text-background-50">
              <i className="ri-sword-fill text-lg" aria-hidden="true" />
            </span>
            <span className="font-heading text-2xl text-background-50 leading-none">
              动漫<span className="text-primary-400">网</span>
            </span>
          </Link>
          <p className="mt-4 text-sm leading-relaxed text-foreground-400">
            {siteInfo.slogan}。收藏动漫网官网首页直达链接，想看番直接进，不用再搜来搜去。
          </p>
          <div className="mt-5 flex gap-3">
            <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-weibo-fill" aria-hidden="true" />
            </a>
            <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-bilibili-fill" aria-hidden="true" />
            </a>
            <a href="#" aria-label="知乎" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
              <i className="ri-zhihu-fill" aria-hidden="true" />
            </a>
          </div>
        </div>

        <nav aria-label="快速链接">
          <h3 className="font-heading text-lg text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/" className="text-foreground-400 hover:text-primary-400 transition-colors">动漫网首页</Link></li>
            <li><Link to="/category" className="text-foreground-400 hover:text-primary-400 transition-colors">动漫分类</Link></li>
            <li><Link to="/articles" className="text-foreground-400 hover:text-primary-400 transition-colors">新番资讯</Link></li>
            <li><Link to="/about" className="text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
          </ul>
        </nav>

        <nav aria-label="动漫分类">
          <h3 className="font-heading text-lg text-background-50">热门分类</h3>
          <ul className="mt-4 grid grid-cols-2 gap-3 text-sm">
            {categories.map((c) => (
              <li key={c.id}>
                <Link to={`/category/${c.id}`} className="text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-lg text-background-50">订阅动漫网</h3>
          <p className="mt-4 text-sm text-foreground-400">
            订阅我们，第一时间获取新番资讯、补番指南与动漫网入口动态。
          </p>
          <div className="mt-4">
            <NewsletterForm />
          </div>
          <div className="mt-5 space-y-2 text-sm text-foreground-400">
            <p className="flex items-center gap-2"><i className="ri-mail-line" aria-hidden="true" />{siteInfo.email}</p>
            <p className="flex items-center gap-2"><i className="ri-phone-line" aria-hidden="true" />{siteInfo.phone}</p>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 px-4 md:px-6 py-5 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 动漫网 dongmanwang.cn 版权所有</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line" aria-hidden="true" />
            {siteInfo.icp}
          </p>
        </div>
      </div>
    </footer>
  );
}